const FilterLevel2and3 = (props) => {
  const { activeL2, activeL3, category, handleFilterChange } = props;

  return (
    <li
      className={
        (activeL2 || activeL3).includes(category.id.toString()) ? 'active' : ''
      }
      data-id={category.id.toString()}
      onClick={(e) => {
        handleFilterChange(e);
      }}
    >
      {category.name}
      <span className='tick'></span>
    </li>
  );
};

export default FilterLevel2and3;
